import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';
import { StoreMembership } from 'src/app/core/store-memberships.service';
import { SELLER_DETAILS_STORES_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-seller-details-general-stores',
  templateUrl: './seller-details-general-stores.component.html',
  styleUrls: ['./seller-details-general-stores.component.scss'],
})
export class SellerDetailsGeneralStoresComponent {
  @Input() stores: StoreMembership[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = SELLER_DETAILS_STORES_TABLE_COLUMNS;

  constructor(private navigation_service: NavigationService) {}

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  onSellerDetailClick(store_id: string, company_id: string) {
    this.navigation_service.toStoreDetails(company_id, store_id);
  }
}
